<template>
  <div class="login-pages">
    <a-modal
      v-model:open="showModal"
      title="选择登录子账号"
      :width="600"
      :destroyOnClose="true"
      :maskClosable="false"
      :closable="false"
      :keyboard="false"
      :cancelButtonProps="{
        disabled: true
      }"
      :confirm-loading="confirmLoadingStatus"
      @ok="handleConfirmLoginSonAccount"
    >
      <div class="sub-account-list">
        <div
          class="sub-account-item"
          :class="
            selectSonAccount.userId === item.userId
              ? 'active-sub-account-item'
              : ''
          "
          v-for="item in sonAccountList"
          :key="item.userId"
          @click="handleSelectSonAccount(item)"
        >
          <div class="shop-name">{{ item.shopName }}</div>
          <div class="select-icon">
            <img
              v-if="selectSonAccount.userId === item.userId"
              :src="icons.badgeIcon"
              alt=""
            />
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script lang="ts" setup>
import { ref, defineExpose, getCurrentInstance, defineEmits } from "vue";
import { SubAccountListItem } from "@/views/Login/_interface";
import { SELECTED_BADGE_IMG } from "@/views/Login/_static";
import { postLoginSonAccountApi } from "@/views/Login/_apis";

/** 导出事件 */
const Emits = defineEmits(["loginSonAccountSuccess"]);
/** 导入提示 */
const Message =
  getCurrentInstance()?.appContext.config.globalProperties.$message;

const icons = ref({
  badgeIcon: SELECTED_BADGE_IMG
});
/** 展示选择子账号登录弹窗 */
const showModal = ref<boolean>(false);
/** 登录加载状态 */
const confirmLoadingStatus = ref<boolean>(false);
/** 子账号列表 */
const sonAccountList = ref<SubAccountListItem[]>([]);
/** 选择的子账号 */
const selectSonAccount = ref<SubAccountListItem>({
  shopName: "",
  userId: 0
});

/** 确定选择的子账号 */
const handleSelectSonAccount = (item: SubAccountListItem) => {
  selectSonAccount.value = item;
};

/** 确定选择登录 */
const handleConfirmLoginSonAccount = async () => {
  if (selectSonAccount.value) {
    const res = await postLoginSonAccountApi({
      mainUserId: selectSonAccount.value.userId
    });
    if (res.status !== "200") return;
    Message.info("登录成功，跳转中...");
    let userInfo = {
      userName: '',
      userAvatar: '',
      identityType: ''
    }
    userInfo.userName = res.data.userName;
    userInfo.userAvatar = res.data.userAvatar;
    userInfo.identityType = res.data.identityType;
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
    localStorage.setItem("token", res.data.token);
    Emits("loginSonAccountSuccess");
    Message.destroy();
  } else {
    Message.warning("请选择子账号");
  }
};

/** 展示弹窗 */
const show = (data: SubAccountListItem[]) => {
  selectSonAccount.value = {
    shopName: "",
    userId: 0
  };
  sonAccountList.value = data;
  showModal.value = true;
};

/** 声明父组件调用的方法 */
defineExpose({
  show
});
</script>

<style lang="scss" scoped>
.select-icon {
  position: absolute;
  bottom: 0;
  right: 0;
  img {
    width: 20px;
    height: 20px;
  }
}
.sub-account-item {
  position: relative;
  width: 200px;
  height: 100px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2c2c2c;
  font-weight: bold;
  &.active-sub-account-item {
    border: 2px solid #32788a !important;
    color: #32788a !important;
  }
}
.sub-account-list {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
